import React, { useState, useRef, useEffect } from "react";
import ChangeClassStatusPopup from "./ChangeClassStatusPopup";
import RescheduleClassPopup from "./RescheduleClassPopup";
import ThinkingImg from "../Assets/ThinkingImg.png";

const ShowMappedLearnerClasses = ({ schedule, totalClasses, CourseInstructors, setError, EnrollmentId }) => {
  const [activeRow, setActiveRow] = useState(null);
  const dropdownRef = useRef(null);
  const [showReschedulePopup, setShowReschedulePopup] = useState(false);
  const [showStatusChangePopup, setShowStatusChangePopup] = useState(false);
  const [rescheduleData, setRescheduleData] = useState(null);
  const [statusPopupData, setStatusPopupData] = useState(null);
  const [classStatusChangeSuccessPopup, setClassStatusChangeSuccessPopup] = useState(false);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveRow(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "Scheduled":
        return "#FEF5C5";
      case "Missed":
        return "#EAE1FF";
      case "Completed":
        return "#D2FFDD";
      case "Rescheduled":
        return "#DBEAFF";
      case "Cancelled":
        return "#FFDCDC";
      case "Delivered":
        return "#F6D9FF";
      default:
        return "#FEF5C5";
    }
  };

  const getClassTypeColor = (type) => {
    switch (type) {
      case "Online":
        return "#FC000059";
      case "Driving":
        return "#B1FFC4";
      case "InClass":
        return "#5298F570";
      default:
        return "#FC000059";
    }
  };

  const formatDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const day = start.toLocaleString("en-US", { weekday: "long" });
    // const date = start.toLocaleString("en-US", { day: "2-digit", month: "short" }).toUpperCase();
    const date = start.toLocaleString("en-US", { month: "short" }).toUpperCase(); // <-- fixed
    const timeStart = start.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    const timeEnd = end.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

    return { day, date, dateNum: start.getDate(), time: `${day}, ${timeStart} - ${timeEnd}` };
  };

  return (
    <>
      {schedule.map((item) => {
        const { day, date, dateNum, time } = formatDate(item.startDate, item.endDate);
        const statusColor = getStatusColor(item.classStatus);
        const typeColor = getClassTypeColor(item.ClassType);

        return (
          <div
            key={item.EventId}
            className="w-full rounded-[9px] py-[15px] px-[25px] flex justify-between mt-[30px]"
            style={{ border: "1px solid #A4A4A4", position: "relative" }}
          >
            {/* Left side */}
            <div className="flex gap-[20px]">
              <div className="flex flex-col items-center gap-[5px]">
                <p className="text-[22px] font-semibold">{date}</p>
                <p className="text-[22px] font-semibold">{dateNum}</p>
              </div>

              <div className="flex flex-col gap-[5px]">
                <p className="text-[22px] font-semibold">{time}</p>
                <div
                  className="w-[125px] h-[37px] rounded-[7px] flex justify-center items-center"
                  style={{ backgroundColor: statusColor }}
                >
                  <p className="text-[20px] font-semibold">{item.classStatus}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-[10px]">
                <p className="text-[22px] font-semibold text-center">Feedback</p>
                <p className="text-[18px]">{item.ClassFeedback}</p>
            </div>

            {/* Right side */}
            <div className="flex items-center gap-[20px] relative">
              <p className="text-[22px] font-semibold">Class {item.ClassNo}/{totalClasses}</p>
              <div
                className="w-[97px] h-[37px] rounded-[7px] flex justify-center items-center"
                style={{ backgroundColor: typeColor }}
              >
                <p className="text-[20px] font-semibold">{item.ClassType}</p>
              </div>

              <button
                className="w-[37px] h-[37px] mb-[20px] flex justify-center items-center relative font-bold px-2 rounded cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveRow(activeRow === item.EventId ? null : item.EventId);
                }}
              >
                    <p className="w-full h-full font-bold text-lg flex justify-center items-center">&#x2026;</p>
              </button> 


              {/* Dropdown */}
              {activeRow === item.EventId && (
                <div
                  ref={dropdownRef}
                  className="absolute top-full right-0 mt-2 w-40 bg-white shadow-lg rounded-[8px] z-[999]"
                  style={{ transform: "translateY(10px)" }}
                >
                  <div className="flex flex-col justify-start items-start py-[10px]">
                    <div
                      className="w-full py-2 pl-[20px] text-[20px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                      onClick={(e) => {
                          e.stopPropagation();
                          setRescheduleData({
                            eventId: item.EventId,
                            classStatus: item.classStatus,
                            date,       // ✅ formatted
                            time,       // ✅ formatted
                            dateNum,
                          });
                          setShowReschedulePopup(true);
                          setActiveRow(null); // ✅ CLOSE the dropdown
                        }}
                    >
                      Reschedule
                    </div>
                    <div
                      className="w-full py-2 pl-[20px] text-[20px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                      onClick={(e) => {
                          e.stopPropagation();
                          setStatusPopupData({
                            eventId: item.EventId,
                            status: "Missed",
                            text: "Do you want to mark this class as missed?",
                            btnText: "Mark as Missed"
                          });
                          setShowStatusChangePopup(true);
                          setActiveRow(null); // ✅ CLOSE the dropdown
                      }
                      }
                    >
                      Missed
                    </div>
                    <div
                      className="w-full py-2 pl-[20px] text-[20px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                      onClick={(e) => {
                          e.stopPropagation();
                          setStatusPopupData({
                            eventId: item.EventId,
                            status: "Cancelled",
                            text: "Do you want to mark this class as cancelled?",
                            btnText: "Mark as cancel"
                          });
                          setShowStatusChangePopup(true);
                          setActiveRow(null); // ✅ CLOSE the dropdown
                      }
                      }
                    >
                      Cancelled
                    </div>
                    <div
                      className="w-full py-2 pl-[20px] text-[20px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                      onClick={(e) => {
                          e.stopPropagation();
                          setStatusPopupData({
                            eventId: item.EventId,
                            status: "Completed",
                            text: "Do you want to mark this class as Completed?",
                            btnText: "Mark as Completed"
                          });
                          setShowStatusChangePopup(true);
                          setActiveRow(null); // ✅ CLOSE the dropdown
                      }
                      }
                    >
                      Complete
                    </div>
                  </div>
                </div>
              )}

              {showReschedulePopup && (
                <RescheduleClassPopup
                    CourseInstructors={CourseInstructors}
                    setError={setError}
                    rescheduleData={rescheduleData}
                    setShowReschedulePopup={setShowReschedulePopup}
                    EnrollmentId={EnrollmentId}
                    schedule={schedule}
                    setClassStatusChangeSuccessPopup={setClassStatusChangeSuccessPopup}
                    classStatusChangeSuccessPopup={classStatusChangeSuccessPopup}
                />
              )}

              {showStatusChangePopup && (
                <ChangeClassStatusPopup
                    setShowPopup={setShowStatusChangePopup}
                    heading="Are you sure?"
                    text="Do you want to mark this class as cancellled?"
                    btnText="Cancel Class"
                    onClick={() => setShowStatusChangePopup(false)} // <-- Add this line
                    imageSrc={ThinkingImg} // ✅ Dynamic image source
                    statusPopupData={statusPopupData}
                    setError={setError}
                />
            )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ShowMappedLearnerClasses;
